module.exports = __webpack_public_path__ + "static/media/wabi.e0cc4c3c.png";